import { render, staticRenderFns } from "./ReCardTaskEnds.vue?vue&type=template&id=f3a199e0"
import script from "./ReCardTaskEnds.vue?vue&type=script&lang=js"
export * from "./ReCardTaskEnds.vue?vue&type=script&lang=js"
import style0 from "./ReCardTaskEnds.vue?vue&type=style&index=0&id=f3a199e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports